import { render } from "./ManageArticlesView.vue?vue&type=template&id=3ab2d98c&scoped=true&ts=true"
import script from "./ManageArticlesView.vue?vue&type=script&lang=ts"
export * from "./ManageArticlesView.vue?vue&type=script&lang=ts"

import "./ManageArticlesView.vue?vue&type=style&index=0&id=3ab2d98c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab2d98c"]])

export default __exports__